import React from 'react'
import { Dropdown, Space } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { set_setting } from '../../../../redux/slice/settings'

const LanguageSelector = () => {
  const dispatch = useDispatch()
  const locale = useSelector(s => s._settings.locale)

  const changeLang = ({ key }) => {
    dispatch(
      set_setting({
        setting: 'locale',
        value: key,
      }),
    )
  }

  const items = [
    {
      key: 'en',
      label: 'EN',
    },
    {
      key: 'ro',
      label: 'RO',
    },
  ]

  return (
    <div
      style={{
        marginRight: '.5rem',
      }}
    >
      <Dropdown
        menu={{
          items,
          onClick: changeLang,
          selectedKeys: [locale],
        }}
        trigger={['click']}
      >
        <Space>
          <strong style={{ textTransform: 'uppercase' }}>{locale}</strong>
          <DownOutlined />
        </Space>
      </Dropdown>
    </div>
  )
}

export default LanguageSelector
